import styled from 'styled-components';
import {
  Autocomplete,
  FormHelperText,
} from '@mui/material';

import colors from '../../../../../styles/colors';
import InputLabel from '../../../../../components/v2/InputLabel';

const DialogBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 40px;
  gap: 20px;
`;

const StyledAutocomplete = styled(Autocomplete)`
  background-color: ${colors.base.alpha};
`;

const StyledOption = styled.div`
  border: 1px solid ${colors.shades.secondary7};
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const StyledInputLabel = styled(InputLabel)`
  font-size: 14px;
  color: ${colors.shades.secondary8};
`;

const SettingSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

const DurationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 5px;
`;

const StyledDurationText = styled(FormHelperText)`
  margin-top: 0;
  font-size: 13px;
  line-height: 14px;
  font-weight: 450;
  color: unset;
`;

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledCheckBoxLabel = styled(FormHelperText)`
  margin: 0;
`;

export {
  DialogBody,
  StyledAutocomplete,
  StyledOption,
  RowContainer,
  ColumnContainer,
  CheckBoxContainer,
  StyledCheckBoxLabel,
  StyledInputLabel,
  SettingSection,
  DurationContainer,
  StyledDurationText,
};
